<div class="video-container">
    <div class="close-icon">
        <mat-icon class="mat-icon notranslate material-icons mat-icon-no-color" style="cursor: pointer;" (click)="cancel()">close</mat-icon>
    </div>
    <iframe width="100%" height="100%" [src]="safeSrc" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
</div>